<template>
  <section id="formulario" class="bg-gray-100 py-12">

    <Form @submit="onSubmit" :validation-schema="schema" class="space-y-4 text-gray-700">

      <div class="container mx-auto px-4 max-w-7xl">

        <div class="w-full text-center">
          <h1 class="font-bold text-gray-800 mb-2 md:text-2xl text-lg">Completá tus datos y te enviaremos la entrada digital al celular y correo electrónico indicado.</h1>
          <h1 class="font-bold text-gray-800 mb-2 md:text-2xl text-lg">Podrás acceder al estadio a partir de las 10:00hs con tu entrada digital y el DNI correspondiente.</h1>
          <h1 class="font-bold text-gray-800 mb-2 md:text-2xl text-lg">Por cada registro recibirás una entrada que te permitirá acceder a los dos partidos.</h1>
        </div>

        <div class="w-full">
          <div class="p-2 flex flex-col items-center max-h-full">
            <img class="max-h-full object-contain max-w-xs" src="@/assets/estadio.png"/>
          </div>
        </div>

        <div class="w-full text-center mt-5">
          <h1 class="font-bold text-gray-800 mb-4">Por favor completá el formulario en su totalidad y podrás disfrutar del partido</h1>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0">
          <div class="w-full px-2">
            <label class="block mb-1">Sector</label>
            <Field name="sector" v-slot="{ handleChange, handleBlur, value }" v-model="formData.sector">
              <Dropdown @blur="handleBlur" @update:model-value="handleChange" :model-value="value" placeholder="Seleccioná el sector" class="w-full md:w-14rem p-inputtext-sm" :options="sectores" optionLabel="descripcion" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="sector" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Nombre</label>
            <Field name="nombre" v-slot="{ field }" v-model="formData.nombre">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Nombre" />
              <span class="text-sm text-red-500 p-error">
                <ErrorMessage name="nombre" />
              </span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/5">
            <label class="block mb-1">Apellido</label>
            <Field name="apellido" v-slot="{ field }" v-model="formData.apellido">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Apellido" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="apellido" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/5">
            <label class="block mb-1">DNI</label>
            <Field name="dni" v-slot="{ field }" v-model="formData.dni">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="DNI" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="dni" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Dirección</label>
            <Field name="direccion" v-slot="{ field }" v-model="formData.direccion">
              <InputText v-bind="field" type="direccion" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="direccion" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-1/2">
            <label class="block mb-1">Localidad</label>
            <Field name="localidad" v-slot="{ field }" v-model="formData.localidad">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Localidad" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="localidad" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2">
            <label class="block mb-1">Institución que te invita</label>
            <Field name="institucionReferencia" v-slot="{ field }" v-model="formData.institucionReferencia">
              <InputText v-bind="field" type="institucionReferencia" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="institucionReferencia" /></span>
            </Field>
          </div>
        </div>

        <div class="flex flex-wrap -mx-2 space-y-4 md:space-y-0 mt-3">
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Mail</label>
            <Field name="mail" v-slot="{ field }" v-model="formData.mail">
              <InputText v-bind="field" type="mail" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="mail" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-2/12">
            <label class="block mb-1">Código de país</label>
            <InputText type="text" v-model="formData.countryCode" class="w-full p-inputtext-sm p-3" readonly />
          </div>
          <div class="w-full px-2 md:w-3/12">
            <label class="block mb-1">Código de área</label>
            <Field name="codigoArea" v-slot="{ field }" v-model="formData.codigoArea">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" placeholder="Sin 0 adelante" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="codigoArea" /></span>
            </Field>
          </div>
          <div class="w-full px-2 md:w-4/12">
            <label class="block mb-1">Teléfono celular</label>
            <Field name="telefonoCelular" v-slot="{ field }" v-model="formData.telefonoCelular">
              <InputText v-bind="field" type="text" class="w-full p-inputtext-sm p-3" />
              <span class="text-sm text-red-500 p-error"><ErrorMessage name="telefonoCelular" /></span>
            </Field>
          </div>
        </div>

        <h1 class="font-bold text-gray-800 mt-5 text-sm">&bull; RECORDÁ QUE NO ES NECESARIO IMPRIMIR EL TICKET</h1>

        <h1 class="font-bold text-gray-800 mt-5 text-sm">&bull; CON EL REGISTRO DECLARO ACEPTAR LOS SIGUIENTES TÉRMINOS Y CONDICIONES</h1>
        <div class="flex flex-wrap py-2 text-xs">
          Las Entradas se entregan al Destinatario en carácter de protocolo motivo por el cual cualquier tipo de comercialización y/o venta de las mismas se encuentra terminantemente prohibida. El Destinatario será el único responsable del incumplimiento de dicha prohibición, inclusive por parte de aquellos beneficiarios que el Destinatario no hubiera identificado. Las Entradas podrán ser únicamente para uso del Destinatario, sus directivos y/o para fines promocionales y de protocolo. El Destinatario deberá cumplir con todas las regulaciones y leyes vigentes incluyendo, pero no limitando a las regulaciones federales, provinciales, de la Asociación del Futbol Argentino, ligas provinciales de futbol, organismos federales y/o provinciales de seguridad deportiva y cualquier otro organismo de seguridad de aplicación, así como con las regulaciones sanitarias vigentes.
          El Destinatario declara y asegura que utilizará las Entradas conforme lo establecido en el presente documento, comprometiéndose a no destinar las Entradas para pagar, ofrecer, prometer o autorizar el pago, directa o indirectamente a cualquier persona o entidad, a fin de influenciar cualquier acto o decisión o para realizar cualquier pago indebido a cualquier Funcionario Público, Oficial Deportivo o a cualquier otro individuo privado. Siendo el Destinatario único responsable ante cualquier incumplimiento con la normativa vigente aplicable, y/o lo establecido en el presente documento, debiendo mantener indemne a Torneos y la AFA ante cualquier reclamo y/o acción en la que se pudiera ver involucrada.
        </div>

        <div class="flex flex-wrap py-2 mt-3">
          <button type="submit" label="REGISTRARME"
            class="mt-4 px-4 py-2 bg-transparent border-black hover:bg-black text-black font-semibold hover:text-white border rounded"
            :disabled="isSubmitting">
            <i v-show="isSubmitting" class="pi pi-spin pi-spinner mr-2"></i>
            <i v-show="!isSubmitting" class="pi pi-check mr-2"></i>REGISTRARME
          </button>
        </div>

      </div>
    </Form>

  </section>
</template>

<script lang="ts">
import * as yup from 'yup';

import { defineComponent } from 'vue';
import { Field, Form, ErrorMessage } from 'vee-validate';
import Swal from 'sweetalert2'

import InputText from 'primevue/inputtext';
import Dropdown from 'primevue/dropdown';

import jsonSectores from '@/data/sectores.json';

import suiteService, { Acreditado, TipoAcreditado, EstadoAcreditado, IdLabelEntity } from 'qreventos-suite/services';
import suiteConfig from '@/services/suite.config';

interface Pais {
  code: string;
  value: string;
}

interface Sector extends IdLabelEntity { }

export default defineComponent({
  name: 'FormSection',
  components: {
    InputText, Dropdown,
    Field, ErrorMessage, Form
  },
  data() {
    return {
      paises: [] as Pais[],
      selectedCountry: { "code": "+54", "value": "Argentina" } as Pais,
      isSubmitting: false,
      sectores: [] as Sector[],
      formData: {
        dni: '',
        nombre: '',
        apellido: '',
        localidad: '',
        institucionReferencia: '',
        telefonoCelular: '',
        codigoArea: '',
        mail: '',
        direccion: '',
        countryCode: '+54',
        sector: undefined as unknown as Sector,
      }
    };
  },
  computed: {
    schema() {
      return yup.object({
        dni: yup.string().required('Ingresá el DNI').min(8, 'Al menos 8 números'),
        nombre: yup.string().required('Ingresá el nombre').min(3, 'Al menos 3 letras'),
        apellido: yup.string().required('Ingresá el apellido').min(3, 'Al menos 3 letras'),
        mail: yup.string().required('Ingresá el correo').email('Correo inválido'),
        localidad: yup.string().required('Ingresá la localidad').min(2, 'Al menos 3 letras'),
        direccion: yup.string().required('Ingresá la dirección').min(2, 'Al menos 3 letras'),
        telefonoCelular: yup.string().required('Ingresá el celular').matches(/^\d+$/, 'Solo se permiten números'),
        codigoArea: yup.string().required('Ingresá el código de área').matches(/^\d+$/, 'Solo se permiten números'),
        sector: yup.mixed().required('Seleccioná el sector al que desea asistir'),
        institucionReferencia: yup.string().required('Ingresá la institución de referencia').min(2, 'Al menos 3 letras'),
      });
    }
  },
  methods: {
    async onSubmit() {
      this.isSubmitting = true;

      try {
        const acreditadoPorDni: Acreditado = await suiteService.findAcreditadoByDni(suiteConfig.evento, suiteConfig.token, this.formData.dni);
        if (acreditadoPorDni) {
          Swal.fire({ 
              title: "Atención", 
              html: "El número de documento informado ya fue acreditado anteriormente con éxito.<br/><br/>Si no te llego el mail con el QR podés presentarte con el DNI ingresado o descargar la invitación ahora", 
              icon: "warning",
              showCancelButton: false,
              showDenyButton: true,
              confirmButtonText: 'DESCARGAR INVITACIÓN',
              denyButtonText: 'TERMINAR',
            }).then((result) => {
              if (result.isConfirmed) {
                window.location.href = "https://apps.qreventos.com/credencial/getCredencial?credencial=128&evento=299&hash=" + acreditadoPorDni.hash + "&pdf=false";
              } else if (result.isDenied) {
                window.location.href = "https://www.torneos.com/es/";
              }
            });

          
          this.isSubmitting = false;
          return;
        }

        let acreditado: Acreditado = new Object() as Acreditado;
        acreditado.tipoAcreditado = { "id": this.formData.sector.id } as TipoAcreditado;
        acreditado.estadoAcreditado = { "id": 2 } as EstadoAcreditado;
        acreditado.dni = this.formData.dni;
        acreditado.nombre = this.formData.nombre;
        acreditado.apellido = this.formData.apellido;
        acreditado.telefono = this.selectedCountry.code + this.formData.codigoArea + this.formData.telefonoCelular;
        acreditado.mail = this.formData.mail;
        acreditado.modificado = 2; // SAVE
        acreditado.cantidad = 1;
        acreditado.notificar = true;

        acreditado.datos = {} as any;
        acreditado.datos["3346"] = this.formData.institucionReferencia;
        acreditado.datos["3347"] = this.formData.localidad;
        acreditado.datos["3348"] = this.formData.direccion;

        await suiteService.saveOrUpdate(suiteConfig.evento, suiteConfig.token, acreditado);

        Swal.fire({
          title: "Acreditación exitosa",
          html: "Hemos recibido sus datos de acreditación con éxito.<br/>Le enviamos un código QR al mail indicado para agilizar su ingreso al evento.",
          icon: "success",
        }).then(() => {
          window.location.href = "https://www.torneos.com/es/";
        });

      } catch (error) {
        this.isSubmitting = false;
        Swal.fire({ title: "Error", text: error + '', icon: "error" });
      }
    }
  },
  async mounted() {
    this.sectores = jsonSectores;
  }
});
</script>
